import styled from 'styled-components'

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`